import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'pa-categorized',
  templateUrl: './pa-categorized.component.html',
  styleUrls: ['./pa-categorized.component.scss']
})

export class CategorizedComponent {

  constructor(
    public router: Router,
    public route: ActivatedRoute
  ) { }

  handleOnPACategoryClick(input) {
    this.router.navigate(['../../pa-categorized', input.code], { relativeTo: this.route });
  }

  handleOnOverAllClick() {
    this.router.navigate(['../../over-all'], { relativeTo: this.route });
  }
}
